// extracted by mini-css-extract-plugin
module.exports = {"item":"L_cv","item__image":"L_cw","item__title":"L_cQ","item__counter":"L_cR","item__active":"L_cS"};